import { render, staticRenderFns } from "./DialogQuestionResults.vue?vue&type=template&id=3e0c9c24&"
import script from "./DialogQuestionResults.vue?vue&type=script&lang=js&"
export * from "./DialogQuestionResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports